import { useRef } from 'react'
import { useGetStaleMediaQuery } from '../api'
import type {
  GridMode,
  StaleMedia,
  StaleMediaPaginationRequest,
} from '../types'

const MAX_RECORDS = 10000

export const useGetStaleMedia = (
  paginationRequest: StaleMediaPaginationRequest,
): StaleMedia => {
  const gridModeRef = useRef<GridMode | null>(null)
  const { isLoading, isFetching, data } =
    useGetStaleMediaQuery(paginationRequest)

  const mediaLoading = isLoading || isFetching
  const rows = data ?? { totalCount: 0, results: [] }

  if (gridModeRef.current === null && data) {
    gridModeRef.current = data.totalCount > MAX_RECORDS ? 'server' : 'client'
  }

  return { gridMode: gridModeRef.current, mediaLoading, rows }
}
